
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  drainLabelWithoutDrain: {
    id: "DrainLabelWithoutDrain.withoutdrain",
    defaultMessage: "without Drain accessories",
  }, 
  drainLabelHoodChromeDrain: {
    id: "DrainLabelHoodChromeDrain.hoodchromedrain",
    defaultMessage: "Hood drain valve chrome",
  }, 
  drainLabelHoodDrain: {
    id: "DrainLabelHoodDrain.hooddrain",
    defaultMessage: "Hood drain valve",
  }, 
  drainLabelSieveDrain: {
    id: "DrainLabelSieveDrain.sievedrain",
    defaultMessage: "Sieve drain valve",
  }, 
  drainLabelEccentric: {
    id: "DrainLabelEccentric.eccentric",
    defaultMessage: "Eccentric waste and overflow fitting",
  },
  drainLabelSiphon: {
    id: "DrainLabelSiphon.siphon",
    defaultMessage: "Siphon XINX140",
  },
});

export default MESSAGES;